import type { ReactElement } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { type Currencies, getPremiumData, selectFlexiForwardRfsPremiumData } from '@/App/tiles/FlexiForward/utils.ts';
import { getFlexiForwardQuote } from '@/store/flexi-forward/helpers/rfs.ts';

export function PremiumAmountDisplay({
  currencies,
  isInternalSales,
}: {
  currencies: Currencies;
  isInternalSales: boolean;
}): ReactElement {
  const { premiumAmount, premiumCurrency, isPremiumReceive } = useFlexiForwardSelector((flexiForward) => {
    const quote = getFlexiForwardQuote(flexiForward.properties.rfs);
    const premiumData = selectFlexiForwardRfsPremiumData(quote);

    const { currency1, currency2 } = currencies;

    const isUpfrontCurrency2 = flexiForward.properties.upfrontCurrency === currency2;
    const premiumCurrencyIndex = isUpfrontCurrency2 ? 2 : 1;
    const premiumCurrency = isUpfrontCurrency2 ? currency2 : currency1;

    const { premiumAmount } = getPremiumData(premiumData, premiumCurrencyIndex);

    return {
      premiumAmount,
      premiumCurrency,
      isPremiumReceive: premiumAmount < 0,
    };
  });

  return (
    <div className="d-flex text-nowrap fs-12 line-height-1 ms-1">
      <FormattedMessage
        id={`flexiForwardTile.rates.streaming.AskAmount.${isPremiumReceive ? 'receive' : 'pay'}`}
        values={{ isInternalSales }}
      />
      <div className="fw-semibold ps-4px">
        <FormattedNumber value={Math.abs(premiumAmount)} minimumFractionDigits={2} />
        &nbsp;{premiumCurrency ?? ''}
      </div>
    </div>
  );
}
